import { render, staticRenderFns } from "./ads-edit.vue?vue&type=template&id=d632992a&scoped=true"
import script from "./ads-edit.vue?vue&type=script&lang=js"
export * from "./ads-edit.vue?vue&type=script&lang=js"
import style0 from "./ads-edit.vue?vue&type=style&index=0&id=d632992a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d632992a",
  null
  
)

export default component.exports